<script>
    export default {
        KEY_MAPS: 'AIzaSyDeEsoP6jVjTpqWvbW6sj2P3FUDmqU9kCU'
    }
</script>

